import React, { useState } from 'react';

import { ONLY_NUMBER_REGEX } from 'utils/regExp';

/**
 * 콤마 포맷 숫자(가격) 입력 props.
 * 입력 중에는 숫자만 보여주고, 포커스가 빠지면 콤마를 붙인다.
 * 키 입력마다 콤마를 다시 써 넣으면 안드로이드 키보드(조합 입력)가 글자 위치를 잃고
 * 숫자를 엉뚱한 자리에 다시 넣는다 (예: 5000 입력 → 5,500)
 */
function useNumberInputProps(
  value: number,
  onChangeValue: (value: number) => void,
) {
  const [isFocused, setIsFocused] = useState(false);

  return {
    type: 'text',
    inputMode: 'numeric' as const,
    value: isFocused ? String(value) : value.toLocaleString(),
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      onChangeValue(Number(e.target.value.replaceAll(ONLY_NUMBER_REGEX, ''))),
  };
}

export default useNumberInputProps;
